import { defineComponent as _defineComponent } from 'vue'
import { useModal } from 'vue-nice-modal'
import { computed, PropType } from 'vue'
import { EnumModalQueueItemType } from '@xt/client/enums/messageModalQueue/index'

// useModal 从 vue-nice-modal 获取当前 modal 实例（可解析/拒绝/显示/隐藏）

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  type: { type: String as PropType<EnumModalQueueItemType>, required: true },
  title: { type: String, required: true },
  subTitle: { type: String, default: '' },
  description: { type: String, default: '' },
  backgroundUrl: { type: String, default: '' },
  layoutClassName: { type: String, default: '' },
  bizId: { type: [String, Number] as PropType<string | number>, default: '' },
  hideCancel: { type: Boolean, default: false },
  cancelText: { type: String, default: '关闭' },
  confirmText: { type: String, default: '去浏览' }
},
  setup(__props) {

const props = __props;

const modal = useModal()



const isRecruitModel = computed(() => props.type === EnumModalQueueItemType.Recruit)
const isInitModel = computed(() => props.type === EnumModalQueueItemType.Init)
const isExitModel = computed(() => props.type === EnumModalQueueItemType.Exit)

function handleCancel() {
  modal.resolve({
    status: 'cancel'
  })
  modal.hide()
}

function handleConfirm() {
  if (!isExitModel.value && props.bizId) {
    window.open(`/topic/city/${props.bizId}`, '_blank')
  }

  modal.resolve({
    status: 'ok'
  })
  modal.hide()
}

return { __sfc: true,modal, props, isRecruitModel, isInitModel, isExitModel, handleCancel, handleConfirm }
}

})